<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4>Admin Dashboard</h4>
          </div>

          <div class="card-body">
            <form [formGroup]="AdminBarChartForm">
              <div class="col-md-12">
                <div class="row">
                  <div style="display: block;" id="mychart">
                    <h6>Service Requests By Priority</h6>
                    <br>
                    <!-- Canvas element for Chart.js to render the bar chart -->
                    <canvas id="myChart"></canvas>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4>Admin Dashboard </h4>
          </div>

          <div class="card-body">
            <form [formGroup]="AdminBarChartForm">
              <div class="col-md-12">
                <div class="row">
                  <div style="display: block;" id="mychart">
                    <h6>Service Requests By Priority</h6>
                    <br>
                    <canvas baseChart
  [datasets]="barChartData"
  [labels]="barChartLabels"
  [options]="barChartOptions"
  [legend]="barChartLegend"
  [chartType]="barChartType">
</canvas>

                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->